import { createFileRoute } from "@tanstack/react-router";

import { HowtoIndex } from "../components/howto/HowtoIndex";
import { howtoIndexHead } from "../lib/howto/head";
import { loadHowto } from "../lib/howto/index";
import { HOWTO_UI } from "../lib/howto/ui";
import { documentHeaders } from "../lib/seo";

/** The guides hub in English, at `/how-to`. */
export const Route = createFileRoute("/how-to/")({
  loader: () => loadHowto("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? howtoIndexHead("en", HOWTO_UI.en, loaderData) : {},
  component: EnglishGuides,
});

function EnglishGuides() {
  const bundle = Route.useLoaderData();
  return <HowtoIndex lang="en" ui={HOWTO_UI.en} bundle={bundle} />;
}
